import '@css/style.less'
import '@shared/components'

import Vue from 'vue'
import App from './app/index.vue'
import router from './router'
import store from '@store/store'

import feathers from '@plugins/feathers'
import flits from '@plugins/flits'
import http from '@plugins/http'
import bus from '@plugins/bus'
import drag from '@plugins/drag'
import modal from '@plugins/modal'

import MoleculeRepository from '@repositories/molecules'
import EnzymeRepository from '@repositories/enzymes'

import MixinAuthentication from '@mixins/authentication'

Vue.use(feathers)
Vue.use(flits)
Vue.use(http)
Vue.use(bus)
Vue.use(drag)
Vue.use(modal)

class Application {

  get http() {
    return this.vm.$http
  }

  get flits() {
    return this.vm.$flits
  }

  get store() {
    return this.vm.$store
  }

  get feathers() {
    return this.vm.$feathers
  }

  public vm: Vue

  constructor() {
    this.initVariables()
    this.setData()
    this.initVue()
    this.initIcons()
  }

  private async setData() {
    Vue.prototype.$molecules = new MoleculeRepository()
    Vue.prototype.$enzymes = new EnzymeRepository()
  }

  private initVariables() {
    Vue.config.productionTip = false
  }

  private initIcons() {
    //
    // include SVG icon sprite
    //
    const div = document.createElement('div')
    const body = document.body

    /* tslint:disable */
    div.style.cssText = 'border: 0; clip: rect(0 0 0 0); height: 0; overflow: hidden; padding: 0; position: absolute; width: 0;'
    div.innerHTML = require('!!html-loader!@img/icons.svg')
    body.insertBefore(div, body.childNodes[0])
  }

  private initVue() {
    this.vm = new Vue({
      router,
      store,
      mixins: [
        MixinAuthentication,
      ],
      render: (h) => h(App),
    }).$mount('#app')
  }
}

export default new Application()
